import { hasChildWithId, removeBotFromDOM } from '@/utils/bot-dom';
import * as React from 'react';

interface IRemoveChatbotGuardProps {
  children: React.ReactNode;
}

const RemoveChatbotGuard: React.FunctionComponent<IRemoveChatbotGuardProps> = ({ children }) => {
  React.useEffect(() => {
    const targetNode = document.body;

    if (!targetNode) return;

    const childNodes = targetNode.childNodes;
    const hasBotFrame = hasChildWithId(childNodes, 'askiot-bot-ui');
    const hasBotButton = hasChildWithId(childNodes, 'askiot-chat-icon');
    let allAddedNodes: any = [];

    // If bot frame and button are already present, remove them from DOM
    if (hasBotFrame && hasBotButton) {
      removeBotFromDOM();
      return;
    }

    // Listen for changes, If bot frame and bot button are added to DOM then remove them from DOM
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          allAddedNodes = [...allAddedNodes, ...Array.from(mutation.addedNodes)];
          const hasBotFrame = hasChildWithId(allAddedNodes, 'askiot-bot-ui');
          const hasBotButton = hasChildWithId(allAddedNodes, 'askiot-chat-icon');

          if (hasBotFrame && hasBotButton) {
            removeBotFromDOM();
          }
        }
      }
    });

    observer.observe(targetNode, {
      childList: true, // Listen for addition/removal of child nodes
      subtree: true, // Listen for changes to all descendants
    });

    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, []);

  return children;
};

export default RemoveChatbotGuard;
